export const AUTH_ERROR_CODES = ['UNAUTHENTICATED', 'FORBIDDEN', 'AUTH_EXCEPTION'];

/**
 * Global GraphQL error handler for the GraphQLProvider.
 * Updated for application-commons-graphql v7.0.0 which provides `errors` directly.
 *
 * @param {object} params - The error callback parameters
 * @param {object} params.result - The GraphQL result object
 * @param {Array<ZBError>} params.errors - Array of ZBError instances (new in v7.0.0)
 */
export default function globalGraphQLErrorHandler({ result, errors: zbErrors }) {
  // Ignore account read errors here, so we can handle in component
  // Use the new errors array directly (ZBError instances have errorCode directly on them)
  // Also support legacy format for backward compatibility during migration
  const errors =
    zbErrors?.map?.((error) => ({
      code: error.errorCode || error.extensions?.code || error.extensions?.errorCode,
      message: error.message
    })) ||
    result?.error?.graphQLErrors?.map?.(
      ({ message, extensions: { code, errorCode } = {} } = {}) => ({
        code: code || errorCode,
        message
      })
    ) ||
    [];

  const authError = errors && errors.find(({ code }) => AUTH_ERROR_CODES.includes(code));

  // If someone provides a bad UUID, force re-login
  const invalidBusinessEntityUuidError = errors.find(
    ({ code, message }) =>
      (code === 'FORBIDDEN' && message === 'Permission failure') ||
      (code === 'BAD_USER_INPUT' && message?.includes?.('UUID cannot represent non-UUID'))
  );
  /* if the user is trying to access a resource that returns 403 take them
        to the "home" page of the dashboard.
    */
  if (authError || invalidBusinessEntityUuidError) {
    const { pathname } = window.location;
    if (!pathname || !pathname.startsWith('/dashboard/logout')) {
      window.location.assign(`/dashboard/logout?redirectTo=${pathname}`);
    }
  }
}
